(function ($) {
	function debounce(callback, wait = 300, immediate = false) {
		let timeout = null;

		return function () {
			const callNow = immediate && !timeout;
			const next = () => {
				callback.apply(this, arguments);
				timeout = null;
			};

			clearTimeout(timeout);
			timeout = setTimeout(next, wait);

			if (callNow) {
				next();
			}
		};
	}

	function throttle(callback, wait = 300, immediate = false) {
		let timeout = null;
		let initialCall = true;

		return function () {
			const callNow = immediate && initialCall;
			const next = () => {
				callback.apply(this, arguments);
				timeout = null;
			};

			if (callNow) {
				initialCall = false;
				next();
			}

			if (!timeout) {
				timeout = setTimeout(next, wait);
			}
		};
	}

	const $filterForms = $('.js-ajax');

	if (!$filterForms.length) {
		return;
	}

	$('body').on('click', 'a.js-filter', function (e) {
		e.preventDefault();
		const urlToLoad = this.href;

		// get params array from the url
		let paramsArray = [];

		try {
			paramsArray = urlToLoad
				.split('?')[1]
				.split('&')
				.map((item) => {
					const [name, value] = item.split('=');
					// url decode the name
					let cleanName = decodeURIComponent(name);
					// if the param is an array remove the index from the [] in the name
					cleanName = cleanName.replace(/\[\d+\]/gi, '[]');

					return { name: cleanName, value };
				});
		} catch (e) {
			paramsArray = [];
		}

		// also check the form fields and update them if they are different
		$filterForms[0].querySelectorAll('input, select').forEach(function (item) {
			const $item = $(item);
			const name = $item.attr('name');
			const value = $item.val();

			const itemInArray = paramsArray.filter((item) => {
				return item.name === name && item.value === value;
			});

			if (!itemInArray.length) {
				// if the item is a checkbox or radio
				if (['checkbox', 'radio'].includes($item.attr('type'))) {
					if ($item.prop('checked')) {
						// uncheck it
						$item.prop('checked', false);
						$item.trigger('change');
					}
				} else {
					// otherwise set it to empty
					$item.val('');
				}
			} else {
				// if the item is a checkbox or radio
				if (['checkbox', 'radio'].includes($item.attr('type'))) {
					// check it
					if (!$item.prop('checked')) {
						$item.prop('checked', true);
						$item.trigger('change');
					}
				}
			}
		});

		history.pushState(
			{
				submitUrl: urlToLoad,
				paramsArray: paramsArray,
				urlToLoad: urlToLoad,
			},
			'',
			urlToLoad,
		);

		filterPageAjaxLoad(urlToLoad);
	});

	$('#listing-pagination').on('click', 'a', function (e) {
		e.preventDefault();
		const urlToLoad = this.href;
		const paramsArray = $($filterForms[0]).serializeArray();

		history.pushState(
			{
				submitUrl: urlToLoad,
				paramsArray: paramsArray,
				urlToLoad: urlToLoad,
			},
			'',
			urlToLoad,
		);

		filterPageAjaxLoad(urlToLoad);
	});

	$filterForms.each(function setUPAjaxForm() {
		const $filterForm = $(this);
		const $submitBtn = $filterForm.find('[type="submit"]:not(.js-always-visible)');
		$submitBtn.hide();

		// console.log('set up ajax form', $filterForm);

		const $submitBtnAjax = $filterForm.find('[type="submit"].js-always-visible');
		$submitBtnAjax.on('click', () => {
			// scroll down to #listing
			const $listing = $('#listing');

			if ($listing.length) {
				$('html, body').animate(
					{
						scrollTop: $listing.offset().top - 100,
					},
					600,
				);
			}
		});

		const handleKeyUp = debounce(() => {
			$filterForm.submit();
		}, 400);

		// Nice Select triggers jQuery change, then niceselect.js dispatches a native
		// change ~50ms later. Debounce so those don't fire four AJAX reloads.
		const submitFilters = debounce(() => {
			$filterForm.submit();
		}, 150);

		$filterForm.find('input[type="search"]').on('input change', handleKeyUp);
		$filterForm.find('input[type="text"]').on('input change', handleKeyUp);
		$filterForm.find('input[type="number"]').on('keyup', submitFilters);
		$filterForm.find('input[type="hidden"]').on('change', submitFilters);
		$filterForm.find('input[type="date"]').on('change', submitFilters);
		$filterForm
			.find('input[type="checkbox"], input[type="radio"], select')
			.on('change', submitFilters);

		$filterForm.on('submit', submitForm);

		window.onpopstate = onPopState;

		function submitForm(e) {
			e.preventDefault();

			const url = $filterForm.attr('action');
			const params = $filterForm.serialize();
			const paramsArray = $filterForm.serializeArray();
			const $link = $(`<a href="${url}"></a>`);
			const link = $link[0].href;

			// remove empty params
			const paramsWithoutEmpty = params.split('&').filter((item) => {
				const [name, value] = item.split('=');
				return value !== '' || name === 's';
			});
			const paramsWithoutEmptyString = paramsWithoutEmpty.join('&');

			// get rid of the pagination
			const submitUrl = link.replace(/\/page\/\d+/gi, '');
			const urlToLoad = paramsWithoutEmptyString
				? submitUrl.split('?')[0] + '?' + paramsWithoutEmptyString
				: submitUrl.split('?')[0];

			history.pushState(
				{
					submitUrl: urlToLoad,
					paramsArray: paramsArray,
					urlToLoad: urlToLoad,
				},
				'',
				urlToLoad,
			);

			filterPageAjaxLoad(urlToLoad);
		}

		function onPopState(event) {
			let toLoad = './';

			if (event.state) {
				toLoad = event.state.urlToLoad;

				$filterForm
					.find('input[type="checkbox"]')
					.each(checkShouldBeChecked(event.state.paramsArray));

				// check each input field in the form against the paramsArray update it if it's different
				const $inputs = $filterForm.find('input[type="hidden"]');

				$inputs.each(function AjaxParams(item) {
					const $input = $(this);
					const name = $input.attr('name');
					const value = $input.val();
					const itemInArray = event.state.paramsArray.find((item) => item.name === name);
					let updated = false;

					if (!itemInArray) {
						updated = true;
						$input.val('');
					}

					if (itemInArray && itemInArray.value !== value) {
						updated = true;
						$input.val(itemInArray.value);
					}

					if (updated) {
						$input.trigger('change');
					}
				});

				event.state.paramsArray.forEach(function AjaxParams(item) {
					const $input = $filterForm.find(`input[name="${item.name}"]`);
					const nonUpdateAbleFields = ['checkbox', 'radio'];

					if (nonUpdateAbleFields.includes($input.attr('type'))) {
						$filterForm.find(`input[name="${item.name}"][value="${item.value}"]`).prop('checked');
					}
				});
			}

			filterPageAjaxLoad(toLoad);
		}

		function checkShouldBeChecked(paramsArray) {
			return function AjaxShouldBeChecked() {
				const $checkbox = $(this);
				const name = $checkbox.attr('name');
				const value = $checkbox.val();
				const isInArray = paramsArray.some((item) => item.name === name && item.value === value);

				$checkbox.prop('checked', isInArray);
			};
		}
	});
	let ajaxRequest = null;
	let loadingTimer = null;
	let loadingInterval = null;

	function filterPageAjaxLoad(urlToLoad) {
		const $pagination = $('#listing-pagination');
		const $listing = $('#listing');

		if (ajaxRequest) {
			ajaxRequest.abort();
			ajaxRequest = null;
		}

		if (loadingTimer) {
			clearTimeout(loadingTimer);
			loadingTimer = null;
		}

		if (loadingInterval) {
			clearInterval(loadingInterval);
			loadingInterval = null;
		}

		// we want the list to be loading
		$listing.addClass('listing-loading');

		// it must be "loading" at least 500ms, we will set a counter to remove the class
		// immediately if the ajax call is slower than 500ms
		// or delay the removal of the class if the ajax call is faster than 500ms
		let minTime = 300;
		let counter = 0;
		loadingInterval = setInterval(() => {
			counter += 100;

			if (counter >= minTime) {
				clearInterval(loadingInterval);
				loadingInterval = null;
			}
		}, 100);

		ajaxRequest = $.get(urlToLoad, function AjaxCall(res) {
			ajaxRequest = null;
			const $html = $(res);

			$listing.removeClass('js-reveal-bound');
			$listing.html($html.find('#listing').html() || '');

			if ($pagination.length) {
				$pagination.html($html.find('#listing-pagination').html() || '');
			}

			if (typeof window.runReveal === 'function') {
				window.runReveal();
			}
			// console.log('clear class');
			// console.log(counter, minTime);
			loadingTimer = setTimeout(() => {
				loadingTimer = null;
				const currentOffset = $listing.offset().top;

				if (currentOffset < $(window).scrollTop()) {
					// scroll to top of $listing
					$('html, body').animate(
						{
							scrollTop: $listing.offset().top - 100,
						},
						600,
					);
				}
				$listing.removeClass('listing-loading');
			}, minTime - counter);

			const $itemsToUpdate = $html.find('.js-update-with-ajax-load');
			// console.log($itemsToUpdate);

			if ($itemsToUpdate.length) {
				$itemsToUpdate.each(function () {
					const $item = $(this);
					const id = $item.attr('id');
					const $itemToUpdate = $(`#${id}`);

					if ($itemToUpdate.length) {
						$itemToUpdate.html($item.html());
					}
				});
			}

			try {
				if (window.lazyLoadOptions && typeof LazyLoad !== 'undefined') {
					new LazyLoad(window.lazyLoadOptions);
				}
			} catch (err) {
				console.log('w3 lazyload fail');
			}
		});
	}
})(jQuery);
